// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { MUST_BE_NUMERICAL_VALUE } from 'errors'
import { castToFloat } from 'helpers/reduxFormFunctions'
import { stringIsNumber } from 'validators/common'

const validateMaxPower = (radioData, error) => {
  const {
    maxPower,
    modulations,
  } = radioData

  if (!maxPower) {
    return
  }

  if (!stringIsNumber(maxPower)) {
    error.maxPower = MUST_BE_NUMERICAL_VALUE
    return
  }

  // figure out, of the enabled modulations, what is the greatest enabled power among them.
  // this will determine validation for Max Power's range.
  const highestEnabledPower = modulations.reduce((a, d) => {
    // NOTE - d.power can be undefined because of how redux-form handles
    // if d.power === undefined, then castToFloat will return null
    // https://github.com/erikras/redux-form/issues/3366
    const power = castToFloat(d.power)

    // if the modulation is enabled,
    // and its power value is not null (null here means an empty string or undefined for redux-form value)
    // and if there's not power stored (a) or if this power is greater than the stored power (a < power)
    // then we want to use this modulation's power as the highest. (at least for this time through the reducer)
    if (
      d.enabled &&
      power !== null &&
      (a === null || a < power)
    ) {
      return power
    }

    return a
  }, null)

  if (highestEnabledPower !== null && castToFloat(maxPower) > highestEnabledPower) {
    error.maxPower = `Cannot exceed enabled modulations' greatest power: ${highestEnabledPower}dBm`
  }
}

export default validateMaxPower
